// extracted by mini-css-extract-plugin
export var blue = "_1d-h";
export var brand = "_1d-d";
export var darkGrey = "_1d-g";
export var disabled = "_1d-6";
export var disabledSubtle = "_1d-7";
export var error = "_1d-8";
export var green = "_1d-i";
export var grey = "_1d-f";
export var icon = "_1d-0";
export var inherit = "_1d-c";
export var lightGrey = "_1d-e";
export var orange = "_1d-k";
export var pink = "_1d-m";
export var primary = "_1d-1";
export var purple = "_1d-n";
export var quaternary = "_1d-4";
export var quinary = "_1d-5";
export var red = "_1d-l";
export var secondary = "_1d-2";
export var success = "_1d-b";
export var tertiary = "_1d-3";
export var warning = "_1d-9";
export var warningSecondary = "_1d-a";
export var white = "_1d-o";
export var yellow = "_1d-j";